import Splide from '@splidejs/splide';

let applicationProcedureSlides = document.getElementsByClassName('application-procedure');

document.addEventListener('DOMContentLoaded', function () {
    for (let i = 0; i < applicationProcedureSlides.length; i++) {
        let splide = new Splide(applicationProcedureSlides[i], {
            type: 'slide',
            perPage: 2,
            perMove: 1,
            rewind: true,
            pagination: false,
            arrows: true,
            width: '100%',
            gap: 24,
            breakpoints: {
                640: {
                    perPage: 1,
                    gap: 16,
                },
            },
        });

        let bar = splide.root.querySelector('.splide-progress-bar');

        splide.on('mounted move', function () {
            let end = splide.Components.Controller.getEnd() + 1;
            bar.style.width = String(100 * (splide.index + 1) / end) + '%';
        });

        splide.mount();
    }
});
